<template>
  <div class="bo_nav_headline">
    <h1>{{(currentBoNavigation && currentBoNavigation.name) || title}}</h1>
    <h3>{{currentBoNavigation && (currentBoNavigation.description || currentBoNavigation.internaldescription)}}</h3>
    </div>
</template>
<script>
  import store from '@/store'
  import BettingOffer from '@/components/mixins/BettingOffer'

  export default {
    name: 'SportsBreadcrumb',

    props: [
      'title'
    ],

    mixins: [
      BettingOffer
    ],

    computed: {
      bonavigation1 () {
        return (this.idfwbonavigation1 && this.boNavigation && this.boNavigation[this.idfwbonavigation1]) || undefined
      },
      bonavigation2 () {
        return (this.idfwbonavigation2 && this.boNavigation && this.boNavigation[this.idfwbonavigation2]) || undefined
      },
      currentBoNavigation () {
        if (this.bonavigation1 && this.bonavigation1.idfwbonavigationtypes && this.bonavigation1.idfwbonavigationtypes.filter(bonavtype => bonavtype === 'MAIN').length > 0) {
          return this.bonavigation1 || undefined
        } else {
          return this.bonavigation2 || undefined
        }
      },
      idfoevent () {
        return this.$route.params.idfoevent
      },
      event () {
        return store.getters['eventState/getEvent']
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" scoped>
@import "~@/css/config";

.bo_nav_headline
  text-align: left

  h1
    font-weight: bold
    font-size: 76px
    font-weight: bold
    line-height: 76px
    color: white
    text-transform: uppercase
    text-align: left
    text-shadow: 2px 2px 2px rgba(0, 0, 0, 0.4)

  h3
    font-size: 18px
    text-align: left
    color:white
    font-weight: 600
    max-height: 35px
    overflow: hidden
    line-height: 21px
    opacity: 0.8

@media mobile-big-and-below
  h1
    font-size: 26px !important
    line-height: 30px !important
  h3
    font-size: 15px !important

</style>



// WEBPACK FOOTER //
// src/components/sports/bettingoffer/SportsBreadcrumb.vue